module.exports = __webpack_public_path__ + "img/spotify.1fb21295.png";